/* eslint-disable no-restricted-globals */
import _ from 'lodash';
import constants from '../constants/constants';
import { DateRange } from '@mui/x-date-pickers-pro';
import { Moment } from 'moment/moment';
import { isValidDateRange } from './formatters';

export interface Param {
    key: string;
    value: any;
}

export const isSuccess = function (response) {
    const getStatus = (res) => res?.status || res?.response?.status || res?.data?.status || res?.response?.data?.status;
    let result;
    let status;
    if (_.isArray(response)) {
        result = true;
        response.forEach((res) => {
            status = getStatus(res);
            if (!(res?.status >= constants.STATUS_200 && res?.status < constants.STATUS_300)) {
                result = false;
            }
        });
    } else {
        status = getStatus(response);
        result = status >= constants.STATUS_200 && status < constants.STATUS_300;
    }
    return result;
};
export const getParam = function (name) {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(name);
};
export const getUrlQuery = function () {
    const urlParams = new URLSearchParams(window.location.search);
    const queryParams = urlParams.toString();
    return queryParams.length && queryParams !== 'null' ? `?${queryParams}` : null;
};
export const updateParam = function (name, value, reload?) {
    const urlParams = new URLSearchParams(window.location.search);
    urlParams.set(name, value);
    if (reload) {
        window.location.search = urlParams.toString();
    } else {
        const updatedUrl = `${window.location.protocol}//${window.location.host}${
            window.location.pathname
        }?${urlParams.toString()}`;
        window.history.pushState({ path: updatedUrl }, '', updatedUrl);
    }
};
export const removeParam = function (name, reload?) {
    const urlParams = new URLSearchParams(window.location.search);
    urlParams.delete(name);
    if (reload) {
        window.location.search = urlParams.toString();
    } else {
        const updatedUrl = `${window.location.protocol}//${window.location.host}${
            window.location.pathname
        }?${urlParams.toString()}`;
        window.history.pushState({ path: updatedUrl }, '', updatedUrl);
    }
};

export const copyToClipboard = (value) => {
    const finalValue = value || value === 0 ? value : '';

    if (navigator.clipboard && window.isSecureContext) {
        return navigator.clipboard.writeText(finalValue);
    } else {
        let textArea = document.createElement('textarea');
        textArea.value = finalValue;
        textArea.style.position = 'fixed';
        textArea.style.left = '-999999px';
        textArea.style.top = '-999999px';
        const appendTo = document.querySelector('.MuiDialog-container') || document.body;
        appendTo.appendChild(textArea);
        textArea.focus();
        textArea.select();
        return new Promise((res, rej) => {
            document.execCommand('copy') ? res(finalValue) : rej();
            textArea.remove();
        });
    }
};

export const getQueryStringFromParams = (params: Array<Param>) => {
    const urlParams = new URLSearchParams();
    params.forEach((param) => {
        urlParams.set(param.key, param.value);
    });
    return `?${urlParams.toString()}`;
};

export function addDateRangeParams(params: Array<Param>, dateRange: DateRange<Moment>) {
    if (isValidDateRange(dateRange)) {
        params.push({ key: 'startDate', value: dateRange[0].toISOString() });
        params.push({ key: 'endDate', value: dateRange[1].toISOString() });
    }
}

export function addTagsParams(params: Array<Param>, tags: any) {
    if (tags) {
        params.push({ key: 'tags', value: tags });
    }
}
export function getDateRangeBody(dateRange: DateRange<Moment>) {
    let body: any = {};
    if (isValidDateRange(dateRange)) {
        body = {
            dates: {
                start: dateRange[0]?.toISOString(),
                end: dateRange[1]?.toISOString(),
            },
        };
    }
    return body;
}

export function getTagsBody(tags: any) {
    let body: any = {};
    if (tags) {
        body = {
            tags: tags.split(','),
        };
    }
    return body;
}

export function downloadByteArray(filename: string, byteArray: ArrayBuffer) {
    const blob = new Blob([byteArray], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(link.href);
}

export function toBase64FromArrayBuffer(arrayBuffer: ArrayBuffer) {
    const uint8Array = new Uint8Array(arrayBuffer);
    let binary = '';
    for (let i = 0; i < uint8Array.length; i++) {
        binary += String.fromCharCode(uint8Array[i]);
    }
    return btoa(binary);
}

export function fromBase64ToArrayBuffer(base64: string) {
    const binary = atob(base64);
    const bytes = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i++) {
        bytes[i] = binary.charCodeAt(i);
    }
    return bytes.buffer;
}
